export const DATE_FORMAT = 'MM/YYYY';
export const DATE_PARSE = 'MM/YYYY';

export const DATE_MASK = '__/____';
